import AddAdmin from './AddAdmin';

export default AddAdmin;
